<template>
  <div v-if="userHasAccess">
    <div v-if="(allShows.length > 0)|| isSupportUser">
      <div id="show-header" class="bg-white">
        <div class="flex justify-between items-center py-3 mx-6">
          <h1 class="">Shows</h1>
        </div>
      </div>
      <div class="w-full mx-auto px-0 sm:px-3">
        <div class="bg-white rounded-lg mb-4">
          <tabs type="classic">
            <tab :selected='true' name="Show Details">
              <div class="py-3 px-3">
                <div class='flex justify-between items-center'>
                  <div>
                    <p class="text-3xl font-light">Show List</p>
                    <p class="text-sm text-gray-700">Click to view more</p>
                  </div>
                  <div class="flex items-center">
                    <template v-if="isSupportUser">
                      <add-show-from-template v-if="dynamicClassLists" :event="event"/>
                      <!--<add-show-dynamic v-if="dynamicClassLists" :event="event"/>-->
                      <add-show v-else :event="event"/>
                    </template>
                    <button class="btn-xs btn-green-outline" @click="saveShowOrder">Save Order</button>
                  </div>
                </div>
              </div>
              <div class="flex flex-col justify-center items-center w-full mt-3">
                <draggable v-model="event.shows" group="allShows" ghost-class="ghost" class="w-full" handle=".handle">
                  <div class="flex justify-center items-center w-full px-0 sm:px-6 py-4 hover:bg-gray-200 " v-for="(s, i) in shows" :key="i">
                    <span class="text-xl handle draggable ml-3 mr-3 text-gray-800 cursor-move">&#9776;</span>
                    <div class="flex-1 flex items-center cursor-pointer" @click="editShowClicked(s)">
                      <div class="flex flex-col text-center pr-4 w-24" v-if="s.show_date">
                        <div class="text-md font-medium text-calendar">{{parseDate(s.show_date,'MMM')}}</div>
                        <div class="text-lg font-bold">{{parseDate(s.show_date,'D')}}</div>
                      </div>
                      <div class="flex-1">
                        <div class="show-name text-xl font-bold">{{s.name}}</div>
                        <div class="text-gray-700">
                          {{s.species}} ~
                          <span class="judge" v-if="s.judge">
                          <template v-if="s.judge.judge_id">
                            {{`${s.judge.first_name} ${s.judge.last_name}`}}
                          </template>
                          <template v-else>
                            Judge not selected
                          </template>
                        </span>
                        </div>
                        <div class="text-gray-800 text-sm flex font-medium">
                          <div v-if="event.entry_settings.early_bird_date" class="pr-1">Early-{{currencySymbol}}{{s.pricing_details.early_rate}} |</div>
                          <div class="pr-1">Normal-{{currencySymbol}}{{s.pricing_details.rate}} |</div>
                          <div>Late-{{currencySymbol}}{{s.pricing_details.late_rate}}</div>
                          <!--<div>{{showTypeDecode[s.entry_details_id].label}}</div>-->
                        </div>
                        <span class="text-gray-800 text-sm">Start Time: {{s.start_time}}</span>
                      </div>
                      <!--<div>
                        <button class="btn btn-link" @click="editShowClicked(s)">Edit</button>
                        <button class="btn btn-link" @click="deleteShow(s)">Delete</button>
                      </div>-->
                      <div>
                        <svg viewBox="0 0 32 32" class="text-gray-500 w-8" aria-hidden="true">
                          <path d="M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </tab>
            <tab name="Entry Types" v-if="dynamicClassLists">
              <show-entry-types/>
            </tab>
            <tab name="Class List (NEW)" v-if="isSupportUser && dynamicClassLists">
              <show-class-lists/>
            </tab>
            <tab name="Entry Types (OLD)" v-if="isSuperUser && !dynamicClassLists">
              <div class='flex justify-between items-center py-3 px-6'>
                <div>
                  <p class="text-3xl font-light">Entry Types</p>
                </div>
                <button class="btn btn-green" @click="openModalClicked('eventShowType', {})">New Entry Type</button>
              </div>

              <template>
                <ul role="list" class="divide-y divide-gray-200">
                  <li v-for="show_type in adminData.event_show_types" :key="show_type.entry_details_id" class="py-4">
                    <!-- Your content -->
                    <div class="block hover:bg-gray-100">
                      <div class="px-4 py-4 flex items-center sm:px-6">
                        <div class="truncate" >
                          <div class="flex items-baseline">
                            <p class="font-medium text-blue-600 text-2xl truncate">{{ show_type.label }}</p>
                            <p class="ml-1 flex-shrink-0 font-normal text-gray-700"> ({{ show_type.group_type }})</p>
                            <button class="ml-2 inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded text-blue-700 bg-blue-100 border-blue-200 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" @click="openModalClicked('eventShowType', show_type)">Edit</button>
                          </div>
                          <div class="mt-2 min-w-0 flex-1 md:flex md:items-top md:justify-between py-2 md:py-0 md:space-x-3" >
                            <div id="class_calc">
                              <div class="pb-1 border-b border-gray-200">
                                <p class="font-semibold">Class Calc Details</p>
                              </div>
                              <div class="mt-1 flex">
                                <div class="grid grid-cols-2">
                                  <template v-for="k in Object.keys(show_type.class_calc)" >
                                    <div v-if="k !== 'break_rules'" class="mr-3 mb-2" :key="k">
                                      <p class="text-sm">{{k}} </p>
                                      <p class="text-xs text-gray-600">{{show_type.class_calc[k]}}</p>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                            <div id="entry_fields">
                              <div class="pb-1 border-b border-gray-200">
                                <p class="font-semibold">Entry Fields</p>
                              </div>
                              <div class="mt-1 flex">
                                <div class="grid grid-cols-2" v-for="s in show_type.entry_details" :key="s.label">
                                  <div v-for="f in s.fields" :key="f.label" class="mr-3 mb-2">
                                    <p class="text-sm">{{f.label}} </p>
                                    <p class="text-xs text-gray-600">{{f.type === 'input' ? f.inputType : f.type}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div id="shows">
                              <div class="pb-1 border-b border-gray-200">
                                <p class="font-semibold">Shows</p>
                              </div>
                              <div class="mt-1 space-y-2">
                                <template v-for="(s, si) in event.shows">
                                  <p class="text-sm" v-if="show_type.event_show_type_id === s.entry_details_id" :key="si">
                                    {{s.name}}
                                  </p>
                                </template>
                              </div>
                              <div id="class_list" class='mt-2'>
                                <div class="pb-1 border-b border-gray-200">
                                  <p class="font-semibold">Class List</p>
                                </div>
                                <div class="mt-1 space-y-2">
                                  <p class="text-sm">
                                    {{show_type.class_list_id}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ml-5 flex-shrink-0">
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </template>
            </tab>
            <tab name="Class Lists" v-if="(isSuperUser || isWorldBeefExpo) && !dynamicClassLists" class='p-2'>
              <div class='flex justify-between items-center py-3 px-6'>
                <div>
                  <p class="text-3xl font-light">Class Lists</p>
                </div>
                <button class="btn btn-green" @click="updateToNewConfig">Update to New Config</button>
                <!--<button class="btn btn-green" @click="openModalClicked('classList', {})">New Class List</button>-->
              </div>
              <multiselect class="my-2" v-model="selectedClassList" :options="adminData.class_lists" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a class list" label="classType" :preselect-first="false" :custom-label="(option) => {return option.class_id}" :hideSelected="true"></multiselect>
              <div class="hr"></div>
              <div id="showbook-section" v-if="selectedClassList">
                <div class='flex justify-between my-2' v-if="isSuperUser">
                  <div>
                    <button class="btn-xs btn-green mr-1" @click="saveAllClasses(selectedClassList.class_list)">Save Class List</button>
                    <button class="btn-xs btn-blue-outline" @click="selectedClassList.class_list.push({classType: selectedClassList.class_id,classNumber: selectedClassList.class_list.length + 1})">+ New Class</button>
                    <update-show-order class="mt-2" :classList="selectedClassList.class_list" @updateClassList="divisionOrderUpdated"/>

                  </div>
                  <template v-if="changeClassOrder">
                      <button class="btn-xs btn-blue" @click="saveOrder(selectedClassList.class_list)">Save Order</button>
                  </template>
                  <template v-else>
                    <button class="btn-link" @click="changeClassOrder=true">Click to Change Order</button>
                  </template>
                </div>
                <div v-else-if="isWorldBeefExpo" class="flex justify-between my-2">
                  <template v-if="changeClassOrder">
                      <button class="btn-xs btn-blue" @click="saveOrder(selectedClassList.class_list)">Save Order</button>
                  </template>
                  <template v-else>
                    <button class="btn-link" @click="changeClassOrder=true">Click to Change Order</button>
                  </template>
                </div>
                <draggable v-model="selectedClassList.class_list" ghost-class="ghost" handle=".handle">
                  <div v-for="(c, i) in selectedClassList.class_list" :key="i" class="flex items-center p-1 border-t ">
                    <span v-if="changeClassOrder" class="text-xl handle draggable ml-3 mr-3 text-gray-800 cursor-move">&#9776;</span>
                    <template v-if="isSuperUser">
                      <input class="p-1 border rounded m-1 md:w-full" v-model="c.className" placeholder="Class Name">

                      <input class="p-1 border rounded m-1 w-48" v-model="c.division" placeholder="Division">
                      <!--<input class="p-1 border rounded m-1 w-20" v-model="c.subDivision" placeholder="sub">-->
                      <input class="p-1 border rounded m-1 w-20" v-model="c.entryType" placeholder="entryType">

                      <div v-if="c.ageRangeStart" class="flex-col">
                        <input type="date" class="border-b w-32 text-xs" v-model="c.ageRangeStart">
                        <input type="date" class="border-b w-32 text-xs" v-model="c.ageRangeEnd">
                      </div>
                      <template v-else>
                        <input type="number" class="p-1 border rounded m-1 w-16" v-model="c.ageStart" placeholder="0">
                        <input type="number" class="p-1 border rounded m-1 w-16" v-model="c.ageEnd" placeholder="0">
                      </template>
                      <input class="p-1 border rounded m-1 w-20" v-model="c.break_type" placeholder="break_type">
                      <div>
                        <!--<button class="btn-link" @click="saveClass(c)">Save</button>-->
                        <button class="btn-xs btn-red" @click="deleteClass(selectedClassList.class_list, c, i)" v-if="!c.classID">X</button>
                      </div>
                    </template>
                    <template v-else-if="isWorldBeefExpo">
                      <div>{{c.classNumber}}</div>
                      <input class="p-1 border rounded m-1 md:w-full" v-model="c.className" placeholder="Class Name">
                      <button class="btn btn-green" @click="saveClass(c)">Save</button>
                    </template>
                  </div>
                </draggable>
              </div>
            </tab>
          </tabs>
        </div>
      </div>

      <b-modal size="lg" ref="showModal" title="Show" no-close-on-backdrop>
        <div class="w-full">
          <tabs type="classic">
            <tab :selected="true" name="Show Details" class="mt-4">
              <form @submit.prevent class="w-full">
                <vue-form-generator :schema="showSchema_1" :model="show"/>
                <div class="mt-1 mb-3">
                  <h3>Judge</h3>
                  <showman-type-ahead v-model="show.judge" class="mt-1" :initialValue="show.judge" @valueChange="setJudge" :placeholder="'Start typing to select or change judge'" :label="'Animal'" :dataEndpoint="'/callFunction/judgeSearch'" :schema="judgeTypeAheadSchema" :internalSearch="false" :allowClear="true"></showman-type-ahead>
                  <p class='mt-1 text-gray-700 text-sm font-medium'>**If you can't find your judge, contact your show specialist to get them added in.</p>
                </div>
                <vue-form-generator :schema="showSchema_2" :model="show"/>
                <div class="hr"></div>
                <vue-form-generator :schema="showPricingSchema" :model="show"/>
              </form>
            </tab>
            <tab name="Entry Type" class="mt-4" v-if="isSuperUser">
              <div id="entry_type">
                <h3 class="text-2xl font-light mb-2 pb-1 border-b">Entry Type</h3>
                <v-select
                  class="bg-white rounded mt-1 p-1"
                  v-model="show.entry_details_id"
                  :options="adminData.event_show_types"
                  label="label"
                  :reduce="option => option.event_show_type_id"
                  :clearable="false"
                >
                </v-select>
                <!--Temporary ADMIN Stuff-->
                <!--<p>Update show data</p>
                <button class="btn btn-blue" @click="updateShowEntryData">Update Show Data</button>-->
              </div>
            </tab>
            <tab name="Ring Details" v-if="isSuperUser && show.show_settings" class="mt-4">
              <ConfigureShowRings :displayType="'inline'" @ringUpdate="() => a = 1" :show_book="show"/>
              <v-jsoneditor v-model="show.show_settings.ring_settings" :options="{mode:'code'}" :plus="false" height="600px" class="mt-4"/>
            </tab>
            <tab name="Show Settings" v-if="isSuperUser && show.show_settings">
              <button class="btn btn-blue" @click="reCalcClasses(show.show_id)">Recalc Classes</button>
              <v-jsoneditor v-model="show.show_settings" :options="{mode:'code'}" :plus="true" height="600px" class="mt-4"/>
            </tab>
            <tab name="Adv. Class Settings" v-if="selectedShowType && isSuperUser">
              <div class="flex border-b py-4 w-full justify-between">
                <v-select
                  class="bg-white rounded mt-1 p-1 w-full"
                  v-model="advClassListToAdd"
                  :options="selectedShowType.class_list.filter(c => c.entryType === 'standard' && !show.show_settings.class_settings.find(cs => cs.classID === c.classID))"
                  label="className"
                  :reduce="option => option"
                  :clearable="false"
                >
                </v-select>
                <button class="btn btn-green" @click="addClassAdvSettings">Add Class</button>
              </div>
              <template v-if="this.show.show_settings.class_settings.length">
                <div class="flex justify-between w-full space-x-4 py-1 items-center text-sm font-semibold">
                  <div class="w-full">Class</div>
                  <div class="w-24 text-center">Rate</div>
                  <div class="w-24 text-center">Late Rate</div>
                  <div class="w-24 text-xs text-center">No Entry Fields</div>
                </div>
                <div v-for="(c, ci) in this.show.show_settings.class_settings" :key="ci" class="flex justify-between w-full space-x-4 py-1 items-center border-t">
                  <div class="w-full text-sm">{{ c.className }}</div>
                  <div class="w-24">
                    <input type="number" v-model="c.rate" class="text-sm w-16 new-form-input">
                  </div>
                  <div class="w-24">
                    <input type="number" v-model="c.late_rate" class="w-16 text-sm new-form-input">
                  </div>
                  <div class="w-24 text-center">
                    <input type="checkbox" v-model="c.late_rate" class="">
                  </div>
                </div>
              </template>

            </tab>
          </tabs>
        </div>
        <div slot="modal-footer" class="w-full">
          <div class="flex justify-between items-center mt-8">
            <button class="btn btn-blue" @click="updateShow">Update Show</button>
            <button class="btn btn-red" @click="deleteShow" v-if="isSupportUser">Delete Show</button>
            <button class="btn-gray-outline btn-sm" variant="primary" @click="$refs.showModal.hide()">
              Close
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal ref="eventShowType" :title="`Show Type`" no-close-on-backdrop>
        <edit-entry-type :eventShowType="eventShowType" @saved="$refs.eventShowType.hide()"/>
      </b-modal>

      <b-modal ref="classList" :title="`Class List`">
        <form-generator :form_schema="class_list_schema" :country="event.location_details.country">
        </form-generator>
      </b-modal>
    </div>
    <div v-else>
      <div class="mt-12 text-center sm:w-4/5 lg:w-2/3 mx-auto bg-white p-3 md:p-6 ">
        <h2 class="text-4xl tracking-tight font-light">Show setup in progress</h2>
        <h3 class="mt-5 text-lg font-medium text-gray-900">If you haven't done so already, please send the following information to <a class="link" :href="`mailto:${setupEmail}`">{{setupEmail}}</a> to have your show templates created.</h3>
        <div class="text-left mt-5 text-sm text-gray-900">
            <p><strong>Files</strong> - Logo,  Show rules and any other documents or files that may be useful</p>
            <p><strong>Sponsor Lette</strong>r - If you would like to use the integrated sponsor feature.</p>
            <p><strong>Structure of Individual Shows (See examples below)</strong></p>
            <div class="mt-2 ">
              Market Hogs:
              <ul class="list-disc ml-8">
                <li>2 Rings - Classes broken by weight and breeds</li>
                <li>Breeds: Hampshire, Duroc, Yorkshire, AOB, Crossbred.</li>
                <li>Top 2 chosen in each breed division, top 5 Overall.</li>
              </ul>
            </div>
            <div class="mt-2 ">
              Breeding Heifer:
              <ul class="list-disc ml-8">
                <li>1 Ring - Classes Broken by age and breeds (crossbreds by weight)</li>
                <li>Crossbred broken by weight. Breeds: Angus, Hereford, AOB, Crossbred</li>
                <li>Top 3 chosen in each breed, top 5 overall</li>
              </ul>
            </div>
            <div class="mt-2 ">
              Showmanship:
              <ul class="list-disc ml-8">
                <li>Peewee 0-7, Junior 8-12, Intermediate 13-16, Senior 17-21</li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <NoAccess :section="'Shows'" :admin_email="adminData.show_admin.email"/>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {format, parse} from 'date-fns'
import FormGenerator from '@/components/FormGenerator.vue'
import AddShow from '@/components/admin/AddShow'
// import AddShowDynamic from '@/components/admin/AddShowDynamic'
import AddShowFromTemplate from '@/components/admin/AddShowFromTemplate'
import EditEntryType from '@/components/admin/EditEntryType'
import UpdateShowOrder from '@/components/admin/updateShowOrder'
import VJsoneditor from 'v-jsoneditor'
import ConfigureShowRings from '@/components/admin/ConfigureShowRings.vue'

import ShowEntryTypes from '@/components/admin/ShowEntryTypes'
import ShowClassLists from '@/components/admin/ShowClassLists'

import Vue from 'vue'
import ShowmanTypeAhead from '@/components/ShowmanTypeAhead.vue'
import NoAccess from '@/views/admin/NoAccess.vue'
export default {
  components: {
    draggable,
    FormGenerator,
    EditEntryType,
    AddShow,
    // AddShowDynamic,
    AddShowFromTemplate,
    UpdateShowOrder,
    ShowEntryTypes,
    ShowClassLists,
    ShowmanTypeAhead,
    VJsoneditor,
    ConfigureShowRings,
    NoAccess
  },
  /* props: {
    allShows: Array
  }, */
  data () {
    return {
      // setupEmail: process.env.VUE_APP_SHOW_SETUP_EMAIL,
      show: {},
      showSchema_1: {
        groups: [
          {
            legend: 'Show Details',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Show Name',
                model: 'name',
                placeholder: 'Show Name',
                hint: 'How do you refer to this show? I.E. Boer Goat Blast Show 1 or Boer Goat Blast JABGA Show',
                required: true
              }
              /* {
                type: 'vueMultiSelect',
                label: 'Judge',
                placeholder: 'Select a Judge',
                model: 'judge',
                required: true,
                values: () => {
                  let judges = this.$store.state.judges
                  return judges
                },
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: true,
                  key: 'judge_id',
                  label: 'first_name',
                  customLabel: function (j) {
                    return `${j.first_name} ${j.last_name} ~ ${j.state}`
                  }
                }
              }, */
            ]
          }
        ]
      },
      showSchema_2: {
        groups: [
          {
            legend: '',
            fields: [
              /* {
                type: 'vueMultiSelect',
                label: 'Judge',
                placeholder: 'Select a Judge',
                model: 'judge',
                required: true,
                values: () => {
                  let judges = this.$store.state.judges
                  return judges
                },
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: true,
                  key: 'judge_id',
                  label: 'first_name',
                  customLabel: function (j) {
                    return `${j.first_name} ${j.last_name} ~ ${j.state}`
                  }
                }
              }, */
              {
                type: 'vueMultiSelect',
                label: 'Show Type',
                placeholder: 'Select a type',
                model: 'type',
                required: true,
                values: [
                  'BREEDING',
                  'SHOWMANSHIP',
                  'MARKET',
                  'GROUP',
                  'EXHIBIT'
                ],
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: false
                }
              },
              {
                type: 'vueMultiSelect',
                label: 'Species',
                placeholder: 'Select a species',
                model: 'species',
                required: true,
                values: [
                  'GOATS',
                  'SHEEP',
                  'SWINE',
                  'CATTLE',
                  'DAIRY CATTLE',
                  'DAIRY GOATS',
                  'RABBITS',
                  'POULTRY',
                  'HORSES',
                  'OTHER',
                  'EXHIBITOR'
                ],
                selectOptions: {
                  multiSelect: false,
                  closeOnSelect: true,
                  searchable: false
                }
              },
              {
                type: 'input',
                inputType: 'date',
                label: 'Show Date',
                model: 'show_date',
                required: true,
                format: 'YYYY-MM-DD'
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Show Start Time',
                model: 'start_time',
                required: true,
                hint: 'If there is no hard start time it is ok to put something like 30 min after 1st show ends.'
              },
              {
                type: 'textArea',
                label: 'Details',
                model: 'show_settings.show_details',
                placeholder: 'Additional show details',
                hint: 'Any Additional Info About Show.',
                required: false
              }
            ]
          }
        ]
      },
      judgeTypeAheadSchema: {
        idField: 'judge_id',
        searchField1: 'first_name',
        searchField2: 'last_name',
        displayTemplate: '$1 $2 ~ $3',
        displayFields: ['first_name', 'last_name', 'state']
      },
      eventShowTypeSchema: {
        groups: [
          {
            legend: 'Show Details',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Show Name',
                model: 'name',
                placeholder: 'Show Name',
                hint: 'How do you refer to this show? I.E. Boer Goat Blast Show 1 or Boer Goat Blast JABGA Show',
                required: true
              }
            ]
          }
        ]
      },
      editType: 'new',
      event_show_type_fields: [
        {key: 'label'},
        {
          key: 'group_type',
          label: 'Group'
        },
        {key: 'entry_details'},
        {key: 'sub_entry_details'},
        {key: 'class_calc'},
        {key: 'entry_sections'},
        {key: ' '}
      ],
      class_list_fields: [
        {key: 'class_id'},
        {key: ' '}
      ],
      class_fields: [
        {key: 'className'},
        {key: 'classNumber'},
        {key: 'division'},
        {key: 'subDivision'},
        {key: 'ageStart'},
        {key: 'ageEnd'},
        {key: ' '}

      ],
      eventShowType: {},
      classList: {},
      selectedClassList: null,
      changeClassOrder: false,
      advClassListToAdd: null
    }
  },
  methods: {
    saveOrder (cl) {
      cl.forEach((c, i) => {
        if (c.classNumber !== i + 1) {
          c.classNumber = i + 1
          this.saveClass({
            classID: c.classID,
            classNumber: c.classNumber
          })
        }
      })
      this.changeClassOrder = false
    },
    // Need to fix this...?
    saveShowOrder: function (change) {
      this.allShows.forEach((s, i) => {
        if (s.order !== i + 1) {
          s.show_order = i + 1
          // Doesn't accept passing in any more...
          this.updateShow_(s)
        }
      })
    },
    divisionOrderUpdated: function (newClassList) {
      this.selectedClassList.class_list = newClassList
      this.saveOrder(newClassList)
    },
    editShowClicked: function (show) {
      this.show = show
      // Make sure class settings are set
      if (!this.show.show_settings.class_settings) {
        Vue.set(this.show.show_settings, 'class_settings', [])
      }
      this.editType = 'edit'
      this.$refs.showModal.show()
    },
    deleteShow: function () {
      this.$store.dispatch('removeShow', {show_id: this.show.show_id})
        .then(response => {
          this.notie.alert({
            type: 2,
            text: `Show, ${this.show.name} Successfully Removed`
          })
          this.$refs.showModal.hide()
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error deleting show, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    updateShow: function () {
      if (this.show.show_date === '') {
        this.show.show_date = null
      }

      this.$store.dispatch('updateShow', this.show)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Show, ${this.show.name} Successfully Updated`
          })

          this.$refs.showModal.hide()
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error updating show, please check all fields and try again.<br>If error continues please submit a help ticket.`
          })
        })
    },
    updateShow_: function (show) {
      this.$store.dispatch('updateShow', show)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Show, ${show.name} Successfully Updated`
          })

          this.$refs.showModal.hide()
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error updating show, please check all fields and try again.<br>If error continues please submit a help ticket.`
          })
        })
    },
    parseDate: function (date, f) {
      return format(parse(date), f)
    },
    openModalClicked: function (name, item) {
      Vue.set(this, name, item)
      this.$refs[name].show()
    },
    saveEventShowType: function () {
      this.eventShowType.name = 'event_show_types'

      if (!this.eventShowType.event_show_type_id) {
        this.$store.dispatch('addData', this.eventShowType)
          .then(response => {
            this.$refs.eventShowType.hide()
            this.notie.alert({
              type: 1,
              text: `Entry Type Successfully Saved`
            })
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error creating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      } else {
        this.$store.dispatch('updateData', this.eventShowType)
          .then(response => {
            this.$refs.eventShowType.hide()
            this.notie.alert({
              type: 1,
              text: `Entry Type Updated`
            })
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      }
    },
    saveAllClasses: function (cl) {
      cl.forEach((c, i) => {
        c.classNumber = i + 1
        this.saveClass(c)
      })
    },
    saveClass: function (cl) {
      cl.name = 'class_lists'
      cl.class_list_id = cl.classID

      if (!cl.classID) {
        this.$store.dispatch('addData', cl)
          .then(response => {
            cl.classID = response.data.data.classID
            this.notie.alert({
              type: 1,
              text: `Class Added`
            })
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error creating Class, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      } else {
        this.$store.dispatch('updateData', cl)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Class Updated`
            })
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error Updating class, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      }
    },
    deleteClass: function (cl, c, index) {
      if (c.classID) {

      } else {
        cl.splice(index, 1)
      }
    },
    setJudge (judge) {
      this.show.judge = judge
    },
    reCalcClasses (showID) {
      this.$store.state.apiInstance.post('/entries/recalculate_show_entries', {show_id: showID, show_date: this.show.show_date, use_dynamic: this.event.event_settings.dynamic_class_lists})
        .then(response => {
          if (response.data.data.toReview.length > 0) {
            alert(`${JSON.stringify(response.data.data.toReview)}`)
          }
        })
    },
    updateToNewConfig () {
      this.$store.state.apiInstance.post('/updateClassListsToNewConfig', {event_id: this.event.event_id})
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Updated to new config`
          })
        })
        .catch(e => {
          // console.log(e)
        })
    },
    addClassAdvSettings () {
      this.show.show_settings.class_settings.push({
        classID: this.advClassListToAdd.classID,
        className: this.advClassListToAdd.className
      })
      this.advClassListToAdd = null
    }
    // This was an update that the ABBA National Brahman Show used to add in their show data to the entires..
    // Can I make it a viable option for all??
    /* updateShowEntryData (file) {
      // Perform any necessary file validation or preprocessing here
      // Send the file to the backend for processing
      // const formData = new FormData()
      // formData.append('file', file)
      this.axios.post(process.env.VUE_APP_ROOT_API + `/entries/updateEntryDataFromFile?show_id=${this.show_id}`)
        .then(response => {
          console.log(response)
          // Handle the response from the server if needed
        })
        .catch(() => {
          // Handle any errors that occur during the file upload
        })
    } */
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    userHasAccess () {
      let access = false
      let foundUser = false
      if (this.adminData.admin_id === this.currentUser.user_id || this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2') {
        access = true
      } else {
        this.adminData.event_user_access.forEach(ur => {
          if (ur.user_id === this.currentUser.user_id) {
            foundUser = true
            access = ur.shows_access
          }
        })
      }
      // If still no code set check if included in admin_id then assume it is a show series specialist and set to FULL for now.
      if (!foundUser) {
        if (this.adminData.admin_ids.includes(this.currentUser.user_id)) {
          access = true
        } else if (this.currentUser.role === 'ADMIN') {
          access = true
        }
      }
      return access
    },
    setupEmail () {
      return this.adminData.show_specialist ? this.adminData.show_specialist.email : process.env.VUE_APP_SHOW_SETUP_EMAIL
    },
    dynamicClassLists () {
      return this.event.event_settings.dynamic_class_lists
    },
    isAssesmentUser () {
      if (this.currentUser.user_id === 'KFtUZcXZ1ITCICo8w0kZdJHB65n1' && this.event.event_id === 'ce97824c-1df8-11ef-8e5d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'PaFB62Hpp4V3BlrUFebP3MRNi0g2' && this.event.event_id === '1d7af7ce-1e10-11ef-b2db-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'MhDTB3YTmTgMZB9g2lVoflY1luO2' && this.event.event_id === '636ee696-1e10-11ef-ad80-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'gsXtVouX3HUQZM8qvrVTa2efLOK2' && this.event.event_id === 'a3e57334-1e10-11ef-a269-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === '3PyICPP8s3OPx7F7BIvV3kRx1OD3' && this.event.event_id === 'bd174d14-1e10-11ef-bd1d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'ECXhYgYtmnUmN8i19kP5vZp5Ulj2' && this.event.event_id === '6f670c58-e7ba-11ee-b65a-1248ddbb6de9') {
        return true
      } else {
        return false
      }
    },
    isSupportUser () {
      return this.currentUser.role === 'ADMIN' || this.isSuperUser || this.isAssesmentUser
    },
    isSuperUser () {
      return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === 'yJcDi4z2bffFtKq1jXI3deN8M9r1'
    },
    isWorldBeefExpo () {
      return this.currentUser.user_id === 'ZXWjwaZnqwOvbbAt6Gqdf3xETu63'
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    },
    allShows () {
      let shows = [...this.event.shows]
      shows.forEach(s => {
        s.event_show_type = this.showTypeDecode[s.entry_details_id]
        if (s.event_show_type) {
          s.show_book = s.event_show_type.class_list
        }
      })
      return this.event.shows
    },
    shows () {
      return this.allShows
    },
    showPricingSchema () {
      return {
        groups: [
          {
            legend: 'Pricing',
            fields: this.pricingFields
          }
        ]
      }
    },
    pricingFields () {
      let fields = []

      if (this.event.entry_settings.early_bird_date) {
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Early Rate',
          model: 'pricing_details.early_rate',
          required: true,
          default: 0
        })
      }

      fields.push({
        type: 'input',
        inputType: 'number',
        label: 'Normal Rate',
        model: 'pricing_details.rate',
        required: true,
        default: 0
      })
      fields.push({
        type: 'input',
        inputType: 'number',
        label: 'Late Rate',
        hint: 'If there is no late fee for this show, Please still set this number to be the same as the normal rate. This is to ensure there is always a number to use for the invoicing.',
        model: 'pricing_details.late_rate',
        required: true,
        default: 0
      })
      if (this.event.entry_settings.has_member_pricing) {
        if (this.event.entry_settings.early_bird_date) {
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'Member Early Rate',
            model: 'pricing_details.member_early_rate',
            required: true,
            default: 0
          })
        }
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Member Standard Rate',
          model: 'pricing_details.member_rate',
          required: true,
          default: 0
        })
        fields.push({
          type: 'input',
          inputType: 'number',
          label: 'Member Late Rate',
          model: 'pricing_details.member_late_rate',
          required: true,
          default: 0
        })
      }

      fields.push({
        type: 'checkbox',
        label: 'This Show has Multi-Entry Pricing',
        model: 'pricing_details.multi_entry_pricing',
        hint: 'Only choose this option if you give discounted prices after a certain number of entries.'
      })
      if (this.show.pricing_details) {
        if (this.show.pricing_details.multi_entry_pricing) {
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'After how many entries is the multi-entry pricing applied?',
            hint: 'If the first entry is $20 and the entries after that cost $10. You would put a 1 here.',
            model: 'pricing_details.multi_entry_number',
            required: false
          })
          if (this.event.entry_settings.early_bird_date) {
            fields.push({
              type: 'input',
              inputType: 'number',
              model: 'pricing_details.multi_entry_early_rate',
              label: 'What is the cost for an early entry after the multi-entry tier is reached?',
              hint: 'This is the cost of each EARLY entry following the number above being reached.',
              required: false
            })
          }
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'What is cost of each On-Time entry after the multi-entry tier is reached?',
            hint: 'This is the cost of each entry following the number above being reached.',
            model: 'pricing_details.multi_entry_rate',
            required: false
          })
          fields.push({
            type: 'input',
            inputType: 'number',
            label: 'What is the cost for a late entry after the multi entry tier is reached?',
            hint: 'This is the cost of each LATE entry following the number above being reached.',
            model: 'pricing_details.multi_entry_late_rate',
            required: false
          })
        }
      }

      return fields
    },
    showTypeDecode () {
      var obj = {}
      if (this.event) {
        this.event.show_types.forEach(st => {
          obj[st.event_show_type_id] = st
        })
      }
      return obj
    },
    selectedShowType () {
      return this.showTypeDecode[this.show.entry_details_id]
    },
    event_show_type_schema () {
      return [
        {
          label: 'Entry Type',
          model: this.eventShowType,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Identifier',
              model: 'identifier',
              placeholder: 'Type Label',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Class List ID',
              model: 'class_list_id',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Label',
              model: 'label',
              placeholder: 'Type Label',
              required: true
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Group',
              model: 'group_type',
              placeholder: 'Group',
              required: true
            },
            {
              type: 'json',
              label: 'Entry Fields',
              model: 'entry_details'
            },
            {
              type: 'json',
              label: 'Sub Entry Fields',
              model: 'sub_entry_details'
            },
            {
              type: 'json',
              label: 'Class Cals',
              model: 'class_calc'
            },
            {
              type: 'json',
              label: 'Entry Sections',
              model: 'entry_sections'
            },
            {
              type: 'submit',
              onSubmit: this.saveEventShowType,
              buttonText: 'Save Entry Type'
            }
          ]
        }
      ]
    },
    class_list_schema () {
      return [
        {
          label: 'Class List',
          model: this.classList,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Label',
              model: 'label',
              placeholder: 'Label',
              required: true
            },
            {
              type: 'checkbox',
              label: 'Is Public',
              model: 'is_public'
            },
            {
              type: 'json',
              label: 'Identifier',
              model: 'division_list'
            },
            {
              type: 'json',
              label: 'Classes',
              model: 'classes'
            },
            {
              type: 'json',
              label: 'Class Settings',
              model: 'class_settings'
            },
            {
              type: 'json',
              label: 'AOB Settings',
              model: 'aob_settings'
            }
            /* {
              type: 'submit',
              onSubmit: this.saveClassList,
              buttonText: 'Save Class List'
            },
            {
              type: 'submit',
              onSubmit: this.generateClassList,
              buttonText: 'Generate Class List'
            } */
          ]
        }
      ]
    },
    currencySymbol () {
      return this.Localized.getCurrencyInfo(this.event.location_details.country).symbol
    }
  }
}
</script>

<style>

</style>
